import { ReactNode } from "react";
import { useResponsive } from "../../../responsive/ResponsiveProvider";

export type PublicWorkflowStep = {
  title: string;
  description: string;
  icon: string;
};

type PublicWorkflowStepsProps = {
  title: string;
  description: string;
  steps: ReadonlyArray<PublicWorkflowStep>;
  accentColor?: string;
  borderColor?: string;
  backgroundColor?: string;
  children?: ReactNode;
};

const PublicWorkflowSteps = ({
  title,
  description,
  steps,
  accentColor = "#0f3d63",
  borderColor = "#bfdbfe",
  backgroundColor = "#eff6ff",
}: PublicWorkflowStepsProps) => {
  const mobile = useResponsive().isMobile;

  return (
    <section
      className="mt-3"
      aria-label={title}
      style={{
        border: `1px solid ${borderColor}`,
        borderRadius: "20px",
        padding: mobile ? "1rem" : "1.35rem",
        background: `linear-gradient(135deg, ${backgroundColor} 0%, #ffffff 72%)`,
      }}
    >
      <div style={{ color: accentColor, fontSize: mobile ? "1.3rem" : "1.6rem", fontWeight: 800, textAlign: "center" }}>
        {title}
      </div>
      <p style={{ color: "#5f7488", lineHeight: 1.65, textAlign: "center", margin: "0.55rem auto 0", maxWidth: "800px" }}>
        {description}
      </p>

      <div className={mobile ? "mt-4 flex flex-column align-items-stretch" : "mt-4 flex align-items-stretch justify-content-center"}>
        {steps.map((step, index) => (
          <div key={step.title} className={mobile ? "flex flex-column align-items-center" : "flex align-items-center flex-1"}>
            <div
              style={{
                width: mobile ? "100%" : "18%",
                minWidth: mobile ? undefined : "155px",
                flex: mobile ? undefined : 1,
                border: `1px solid ${borderColor}`,
                borderRadius: "16px",
                padding: "0.9rem",
                background: "#ffffff",
                textAlign: "center",
                boxShadow: "0 8px 18px rgba(15, 61, 99, 0.06)",
              }}
            >
              <div
                className="inline-flex align-items-center justify-content-center"
                style={{ width: "2.25rem", height: "2.25rem", borderRadius: "999px", background: backgroundColor, color: accentColor, fontSize: "1.05rem", marginBottom: "0.5rem" }}
              >
                <i className={step.icon} />
              </div>
              <div style={{ color: accentColor, fontWeight: 800, lineHeight: 1.35 }}>{step.title}</div>
              <div style={{ color: "#5f7488", fontSize: "0.88rem", lineHeight: 1.55, marginTop: "0.4rem" }}>{step.description}</div>
            </div>

            {index < steps.length - 1 ? (
              <div
                className={mobile ? "flex justify-content-center align-items-center" : "flex justify-content-center align-items-center"}
                style={{ color: accentColor, fontSize: "1.35rem", padding: mobile ? "0.35rem 0" : "0 0.45rem", minWidth: mobile ? undefined : "2.2rem" }}
                aria-hidden="true"
              >
                <i className={mobile ? "pi pi-arrow-down" : "pi pi-arrow-right"} />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
};

export default PublicWorkflowSteps;
